import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/**
 * Kod QR jako SVG.
 *
 * SVG, nie canvas: naklejka idzie na drukarkę, a wektor drukuje się ostro w każdej
 * rozdzielczości i nie wymaga liczenia pikseli pod DPI drukarki. Przy okazji da się
 * go pokazać w kontrastowym motywie bez ponownego rysowania.
 *
 * Poziom korekcji **M** (~15%) — naklejka na maszynie szwalniczej żyje w oleju
 * i kurzu, więc częściowo zabrudzony kod nadal ma się czytać. Wyższy poziom (Q/H)
 * zagęszcza moduły, a naklejka ma być mała.
 */
export function Qr({
  tresc,
  rozmiar = 120,
  margines = 2,
}: {
  tresc: string;
  rozmiar?: number;
  /** Cicha strefa w modułach. Norma mówi 4; przy małej naklejce 2 wystarczają. */
  margines?: number;
}) {
  const sciezka = useMemo(() => {
    // Typ 0 = automatyczny dobór wersji do długości treści.
    const kod = qrcode(0, 'M');
    kod.addData(tresc);
    kod.make();

    const modulow = kod.getModuleCount();
    const kawalki: string[] = [];

    for (let wiersz = 0; wiersz < modulow; wiersz += 1) {
      for (let kolumna = 0; kolumna < modulow; kolumna += 1) {
        if (kod.isDark(wiersz, kolumna)) {
          kawalki.push(`M${kolumna + margines} ${wiersz + margines}h1v1h-1z`);
        }
      }
    }

    return { d: kawalki.join(''), bok: modulow + margines * 2 };
  }, [tresc, margines]);

  return (
    <svg
      width={rozmiar}
      height={rozmiar}
      viewBox={`0 0 ${sciezka.bok} ${sciezka.bok}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label={`Kod QR: ${tresc}`}
    >
      <rect width={sciezka.bok} height={sciezka.bok} fill="var(--surface)" />
      <path d={sciezka.d} fill="var(--n-900)" />
    </svg>
  );
}
